"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = Modal;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some do call out some code smells */
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_icon_1 = require("@saatva-bits/pattern-library.components.icon/");
const modal_module_scss_1 = __importDefault(require("./modal.module.scss"));
function Modal({ type = 'popup', children, className, closeButtonClass, closeButtonContent, contentWrapperClassName, hasOverlay = true, isIsolated = false, isModalVisible, modalTitle, titleTagLevel = 3, titleClassName = 't-heading2', modalLabel, onModalClose, overlayId, modalFooter, footerClassName, drawerSlideDirection = 'right', ...other }) {
    const modalRef = (0, react_1.useRef)(null);
    const closeButtonRef = (0, react_1.useRef)(null);
    const previousFocusRef = (0, react_1.useRef)(null);
    // These states are used for the closing animation
    const [isOverlayClosed, setIsOverlayClosed] = (0, react_1.useState)(null);
    const [isDrawerClosed, setIsDrawerClosed] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (isModalVisible) {
            window.addEventListener('keydown', keyListener);
            document.body.classList.add('u-overflow-hidden');
            setIsDrawerClosed(false);
            setIsOverlayClosed(false);
            previousFocusRef.current = document.activeElement;
            // We set focus on the close button immediately the modal is opened
            closeButtonRef.current && closeButtonRef.current.focus();
        }
        return function cleanup() {
            document.body.classList.remove('u-overflow-hidden');
        };
    }, [isModalVisible]);
    const handleModalClose = () => {
        window.removeEventListener('keydown', keyListener);
        document.body.classList.remove('u-overflow-hidden');
        // We check the type of modal to assign the rigt animation
        if (type === 'popup' || type === 'video') {
            setIsOverlayClosed(true);
        }
        if (type === 'drawer' || type === 'panel') {
            setIsDrawerClosed(true);
        }
        // We need this in order to run the animation before unmounting the modal
        // otherwise the modal would unmount in a blink
        setTimeout(() => {
            onModalClose();
        }, 500);
        // We set focus on the last focused element before opening the modal
        previousFocusRef.current && previousFocusRef.current.focus();
    };
    const handleTabKey = (e) => {
        const modalElement = modalRef.current;
        if (!modalElement) {
            return;
        }
        const focusableElements = modalElement.querySelectorAll('a[href], [href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        // This is known as a focus trap, this guarantees the focus will never be
        // outside the modal while it is active
        if (!e.shiftKey &&
            (focusableElements.length === 1 ||
                document.activeElement === lastElement)) {
            firstElement.focus();
            e.preventDefault();
        }
        if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        }
    };
    // This implementation lets us easily add more events if needed
    const keyListenersMap = new Map([
        ['Escape', handleModalClose],
        ['Tab', handleTabKey],
    ]);
    const keyListener = (0, react_1.useCallback)((e) => {
        const listener = keyListenersMap.get(e.code);
        return listener && listener(e);
    }, []);
    const titleId = modalLabel && `${modalLabel.replace(/\s+/g, '-')}-title`.toLowerCase();
    const Title = `h${titleTagLevel}`;
    const titleClasses = (0, classnames_1.default)(modal_module_scss_1.default['modal__header'], titleClassName);
    const footerClasses = (0, classnames_1.default)(modal_module_scss_1.default['modal__footer'], footerClassName);
    const modalClasses = (0, classnames_1.default)(modal_module_scss_1.default['modal'], {
        [modal_module_scss_1.default['popUp']]: type !== 'drawer',
        [modal_module_scss_1.default['popUp--closed']]: isOverlayClosed,
        [modal_module_scss_1.default['popUp--is-video']]: type === 'video',
        [modal_module_scss_1.default['drawer']]: type === 'drawer',
        [modal_module_scss_1.default[`drawer__${drawerSlideDirection}`]]: type === 'drawer',
        [modal_module_scss_1.default[`drawer__${drawerSlideDirection}--closed`]]: type === 'drawer' && isDrawerClosed,
        [modal_module_scss_1.default['modal__video']]: type === 'video',
        [modal_module_scss_1.default['panel']]: type === 'panel',
        [modal_module_scss_1.default['panel--closed']]: type === 'panel' && isDrawerClosed
    }, className);
    const overlayClasses = (0, classnames_1.default)([modal_module_scss_1.default['modal__overlay']], {
        [modal_module_scss_1.default['modal__overlay--closed']]: isOverlayClosed,
        [modal_module_scss_1.default['modal__overlay--is-drawer']]: type === 'drawer',
        [modal_module_scss_1.default['modal__overlay--is-drawer--closed']]: isDrawerClosed,
        [modal_module_scss_1.default['modal__overlay--is-panel']]: type === 'panel',
        [modal_module_scss_1.default['modal__overlay--is-panel--closed']]: isDrawerClosed,
    });
    const contentClasses = (0, classnames_1.default)({
        [modal_module_scss_1.default['modal__content']]: type !== 'video',
        [modal_module_scss_1.default['modal__content--is-video']]: type === 'video',
        [modal_module_scss_1.default['modal__content--is-popup']]: type === 'popup',
        [modal_module_scss_1.default['modal__content--is-panel']]: type === 'panel',
        [modal_module_scss_1.default['modal__content--has-title']]: modalTitle,
        [modal_module_scss_1.default['modal__content--has-footer']]: modalFooter
    }, contentWrapperClassName);
    // Use the default close button class "modal__dialogClose"
    // unless the user passes in their own class
    const closeButtonClasses = (0, classnames_1.default)(closeButtonClass, {
        [modal_module_scss_1.default['modal__dialogClose']]: !closeButtonClass,
        [modal_module_scss_1.default['modal__dialogClose--is-video']]: type === 'video' && !closeButtonClass,
    });
    const overlayProps = {
        className: overlayClasses,
        id: overlayId,
        onClick: () => handleModalClose(),
    };
    // TODO: extract further to separate UI element
    const modal = (0, jsx_runtime_1.jsxs)("div", { "aria-modal": true, role: "dialog", "aria-labelledby": modalTitle ? titleId : undefined, children: [(0, jsx_runtime_1.jsxs)("div", { ref: modalRef, className: modalClasses, "aria-label": modalLabel, role: "presentation", ...other, children: [(0, jsx_runtime_1.jsx)("button", { "data-testid": "modal-close-button", "aria-label": "Close", className: closeButtonClasses, onClick: () => handleModalClose(), ref: closeButtonRef, children: closeButtonContent || ((0, jsx_runtime_1.jsx)(pattern_library_components_icon_1.Icon, { className: modal_module_scss_1.default['modal__closeIcon'], name: "close", alt: "Close Modal", description: "Close Modal", titleId: `${modalTitle}-CloseIcon` })) }), modalTitle && ((0, jsx_runtime_1.jsx)(Title, { id: titleId, className: titleClasses, children: modalTitle })), (0, jsx_runtime_1.jsx)("div", { className: contentClasses, children: children }), modalFooter && ((0, jsx_runtime_1.jsx)("div", { className: footerClasses, children: modalFooter }))] }), hasOverlay && (0, jsx_runtime_1.jsx)("span", { ...overlayProps })] });
    return ((isIsolated)
        ? modal // renders the modal in DOM flow
        : isModalVisible &&
            (0, react_dom_1.createPortal)(// renders the the modal outside of the DOM flow
            modal, document.body));
}
Modal.propTypes = {
    /** Property to control the presentation of the Modal. */
    type: prop_types_1.default.oneOf(['popup', 'drawer', 'video', 'panel']),
    /** Content that will be rendered as children of the Modal. */
    children: prop_types_1.default.node,
    /** Display modal in isolation (without portal) as a standard UI element. */
    isIsolated: prop_types_1.default.bool,
    /** Required property to open the modal. */
    isModalVisible: prop_types_1.default.bool.isRequired,
    /** Required property to close the modal. */
    onModalClose: prop_types_1.default.func.isRequired,
    /** Applies a required custom label to the Modal. */
    modalLabel: prop_types_1.default.string.isRequired,
    /** Applies a custom class to the Modal. */
    className: prop_types_1.default.string,
    /** Applies a custom class to the Modal content. */
    contentWrapperClassName: prop_types_1.default.string,
    /** Applies a custom class to the Modal close button. */
    closeButtonClass: prop_types_1.default.string,
    /** Content that will be rendered as close button of the Modal. */
    closeButtonContent: prop_types_1.default.node,
    /** Applies overlay when the Modal is open. */
    hasOverlay: prop_types_1.default.bool,
    /** Title that will be rendered to the Modal. */
    modalTitle: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.node]),
    /** Property to control the tag title level of the Modal. */
    titleTagLevel: prop_types_1.default.oneOf([1, 2, 3, 4, 5, 6]),
    /** Applies a custom class to the Modal title. */
    titleClassName: prop_types_1.default.string,
    /** Applies a custom id to the Modal overlay. */
    overlayId: prop_types_1.default.string,
    /** Footer that will be rendered to the Modal. */
    modalFooter: prop_types_1.default.node,
    /** Applies a custom class to the Modal footer. */
    footerClassName: prop_types_1.default.string,
    /** Applies the slide animation for the drawer based on direction. */
    drawerSlideDirection: prop_types_1.default.oneOf(['right', 'left'])
};
//# sourceMappingURL=modal.js.map